import {Container} from 'pixi.js';

export class BaseScene extends Container {
    resources(){
        return [];
    }

    bgm(){
        return '';
    }

    async Init(args){
        console.log(args);
    }

    UpdateScene(dt){
        console.log(dt);
    }
}
